import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../config';
import type { RegistrationRequest } from './apiTypes';
import { handleResponse, prepareHeaders } from './apiServiceUtils';
import type { AccessToken } from '../configuration/tokenHandling/tokenSlice';
import { accessToken } from '../configuration/tokenHandling/accessToken';

export const registrationApi = createApi({
    reducerPath: 'registrationApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.IAM_BASE_URL, prepareHeaders }),
    endpoints: builder => ({
        sendRegistration: builder.mutation<void, RegistrationRequest>({
            query: postBody => ({
                url: '/registrations',
                method: 'POST',
                body: postBody,
                responseHandler: async (response: Response) => handleResponse(response),
            }),
        }),
        // TODO use query for test-registration when new endpoint in backend is provided
        //  This endpoint should be secured with scope checks.
        sendTestRegistration: builder.mutation<void, RegistrationRequest>({
            query: postBody => {
                const token = accessToken.getAccessToken() as AccessToken;
                return {
                    url: '/test-registrations',
                    method: 'POST',
                    body: postBody,
                    headers: { authorization: `Bearer ${token}` },
                    responseHandler: async (response: Response) => handleResponse(response),
                };
            },
        }),
    }),
});

export const { useSendRegistrationMutation, useSendTestRegistrationMutation } = registrationApi;
